import { LoaderIcon } from 'fitify-ui/src/Icon/outline/LoaderIcon'

import { Typography } from '../../Typography'

import { StyledButton } from './Button.Styled'
import type { ButtonProps } from './Button.Types'
import { useFitToContent } from './useFitToContent'

export const Button = ({
  children,
  icon,
  isDisabled = false,
  isLoading = false,
  maxWidth,
  size = 'large',
  variant = 'brand',
  ...htmlProps
}: ButtonProps) => {
  const measureKey = typeof children === 'string' ? children : undefined
  const { buttonRef, fitWidth } = useFitToContent({ maxWidth, measureKey })

  return (
    <StyledButton
      {...htmlProps}
      ref={buttonRef}
      disabled={isDisabled}
      $fitWidth={fitWidth}
      $isLoading={isLoading}
      $maxWidth={maxWidth}
      $size={size}
      $variant={variant}
    >
      {isLoading ? (
        <LoaderIcon />
      ) : (
        <>
          {icon}
          <Typography
            $color="inherit"
            $variant={
              size === 'medium'
                ? 'Poppins/T3 - Medium'
                : 'Poppins/T2 - Semibold'
            }
          >
            {children}
          </Typography>
        </>
      )}
    </StyledButton>
  )
}
